import HttpClient from '@/services/http-client'

class ErrorThresholdService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/error-thresholds/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/error-thresholds', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/error-thresholds', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/error-thresholds/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/error-thresholds/' + id)
  }
}

export default () => new ErrorThresholdService()
